<template>
    <img src="/images/spinner.gif" :class="svgClass">
</template>

<script>
export default {
    name: 'spinner',
    props: {
        svgClass: {
            type: String,
            default: 'svg-48'
        },
    }
}
</script>

